import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../../utils/analyticsService';

const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    const pageName = location.pathname === '/' ? 'home' : location.pathname.substring(1).replace(/\//g, '_');
    const pageTitle = document.title || pageName;
    
    analyticsService.logPageView(pageName, pageTitle);
  }, [location]);

  return null; // This component doesn't render anything
};

export default PageViewTracker;
